<script>
import axios from 'axios'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import StatChart from '@components/widget-stat-chart'
import Overview from '@components/overview'
import Member from '@components/member'
import Task from '@components/task'
import Chat from '@components/chat'
import JsonExcel from 'vue-json-excel'
import moment from 'moment'

import {
  getFirestore,
  collection,
  getDocs,
  query,
  orderBy,
  where,
  doc,
  getDoc
} from 'firebase/firestore/lite'
import CryptoJS from 'crypto-js'

import { firebase } from '../../../../../firebase-int'

const firestore = getFirestore(firebase)

// import {
//   revenueAreaChart,
//   targetsBarChart,
//   salesBarChart,
//   //ordersData,
//   bottomOrdersData,
// } from './data'

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: 'Chapters',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    VuePerfectScrollbar,
    Layout,
    StatChart,
    Overview,
    Member,
    Task,
    Chat,
    JsonExcel,
  },
  data() {
    return {
      //revenueAreaChart: revenueAreaChart,
      //targetsBarChart: targetsBarChart,
      //salesBarChart: salesBarChart,
      //ordersData: ordersData,
      //bottomOrdersData: bottomOrdersData,

      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },

      ordersData: [],

      maxHeight: '328px',

      membersInUnion: [],

      noOfMembers: 0,

      agesOne: 0,
      agesTwo: 0,
      agesThree: 0,
      agesFour: 0,

      averageEarning: 0,

      data: [
        {
          name: '16-34',
          value: 1,
        },
        {
          name: '35-54',
          value: 1,
        },
        {
          name: '55-64',
          value: 1,
        },
        {
          name: '65-Above',
          value: 1,
        },
      ],
      chart_json_fields: {
        Title: 'mainTitle',
        Value: 'value',
        'Sub Value': 'subValue',
      },
      chart_json_fields_two: {
        'Product Name': 'name',
        //"Product Value * 1000": "data",
        'Product Value': {
          field: 'data',
          callback: (value) => {
            return `${value}`
          },
        },
      },

      totalMembersValue: 0,
      totalUnionsValue: 0,
      totalResolvedGrievancesValue: 0,
      totalExpectedRevenueValue: 0,
      loadingData: true,

      totalTrainingValue: 0,
      totalContentValue: 0,

      latestMember: {
        name: '-',
        employerId: '-',
      },

      statChart: [
        {
          mainTitle: '- ',
          key: 'page.dashboard.chartTitleThree',
          value: this.totalMembersValue,
          subValue: '10.21%',
          chartColor: '#5369f8',
          icon: 'book-open',
          color: 'primary',
        },
        {
          mainTitle: '-  ',
          key: 'page.dashboard.chartTitleFour',
          value: this.totalUnionsValue,
          subValue: '5.05%',
          chartColor: '#f77e53',
          icon: 'book',
          color: 'success',
        },
        {
          mainTitle: '-   ',
          key: 'page.dashboard.unionMembers',
          value: this.totalResolvedGrievancesValue,
          subValue: '24.05%',
          chartColor: '#43d39e',
          icon: 'users',
          color: 'info',
        },
        {
          mainTitle: '-    ',
          key: 'page.dashboard.unionMembersIncome',
          value: this.averageEarning,
          subValue: '24.05%',
          chartColor: '#43d39e',
          icon: 'dollar-sign',
          color: 'warning',
        },
      ],
      dateConfig: {
        mode: 'range',
      },
      selectedDate: [this.getDatePlusSeven(), this.getCurrentDate()],
      fromDate: this.getDatePlusSeven(),
      toDate: this.getCurrentDate(),
      calendarConfig: {
        wrap: true,
        dateFormat: 'd/m/Y',
        mode: 'range',
        altInput: true,
        altFormat: 'F j, Y',
        time_24hr: false,
      },

      json_fields: {
        'Complete name': 'name',
        City: 'city',
        Telephone: 'phone.mobile',
        'Telephone 2': {
          field: 'phone.landline',
          callback: (value) => {
            return `Landline Phone - ${value}`
          },
        },
      },







      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 12,
      pageOptions: [4, 8, 12, 16, 32, 64],
      filter: null,
      filterOn: [],

      chaptersList: [],
      content: null,
      parentContent: null,
      subChaptersList: [],
      toolsList: [],
      toolsContentList:[],

      sortBy: 'title',
      sortDesc: false,
      fields: [
        { key: 'title', sortable: true },
        { key: 'id', sortable: true },
        { key: 'description', sortable: true },
      ],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
        fileName: '',
      },
      // items: [
      //   {
      //     text: 'Gebi',
      //     href: '/',
      //   },
      //   {
      //     text: this.$route.params.parentContent.title,
      //     href: '/chapter/'+this.$route.params.parentContent.id,
      //   },
      //   {
      //     text: this.$route.params.content.title,
      //     active: true,
      //   },
      // ],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
    filteredItems() {
      //console.log('>>>>>>>>>>>> Search Item: ' + this.filter)
      if (!this.filter) return this.tableData
      // setup the filter function
      let searchValue = this.filter.toLowerCase()
      let filter = (content) =>
        content.title.toLowerCase().includes(searchValue) ||
        this.tagsHaveThisValue(content.tags, searchValue)
      var filteredItems = this.tableData.filter(filter)
      this.totalRows = filteredItems.length
      this.currentPage = 1

      return filteredItems
    },


  },
  async mounted() {
    //await this.initializeData()
    //this.totalRows = this.items.length
    await this.getCourse()
    await this.getChapter()
    this.chaptersList = await this.readChapters()
    this.chaptersList.forEach(element => {
      //if(this.content)
      //if(this.content.subchapters.includs(element.id))
      for (let i = 0; i < this.content.subchapters.length; i++)
        if (this.content.subchapters[i] == element.id)
          //console.log('>>>>>>>>>>>> Param Chapter: '+this.content.subchapters+' | This Chapter: '+element.id+' | Tools: '+element.tools)
          this.gatherTools(element.tools)
    });
    //console.log('>>>>>>>>>>>>>>>. Tools List: ' + this.toolsList)
    this.tableData = await this.readContents()
  },
  methods: {
    gatherTools(toolsList) {
      toolsList.forEach(element => {
        if (element.length > 5)
          this.getTool(element)
      });
    },
    async getTool(toolId) {
      const docRef = doc(firestore, "tool", toolId);
      const docSnap = await getDoc(docRef);
      var tool=null;

      if (docSnap.exists()) {
        //console.log("Document data:", docSnap.data());
        tool = docSnap.data()
        //if(tool.description.length>0)
        if(tool.fileName.length>0)
        {
          tool.title='Tool'
        }
        if(tool.fileName.length==0)
        {
          tool.title='Tip'
        }
        if(tool.description.length==0 && tool.tip.length>0)
        {
          tool.title='Tip'
          //tool.description=tool.tip
        }
        if(tool.description.length==0 && tool.tip.length==0 && tool.link.length>0)
        {
          tool.title='Reference'
          //tool.description=tool.link
        }
        tool.id = docSnap.id
        if(!tool.description.includes('?') && !tool.tip.includes('?'))
        this.toolsContentList.push(tool)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    },
    addAge(age) {
      if (age > 16 && age <= 34) this.agesOne += 1
      else if (age > 34 && age <= 54) this.agesTwo += 1
      else if (age > 54 && age <= 64) this.agesThree += 1
      else if (age > 64) this.agesFour += 1
    },
    async getCourse() {
      const docRef = doc(firestore, "course", this.$route.params.pid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        //console.log("Document data:", docSnap.data());
        this.parentContent = docSnap.data()
        this.parentContent.id = docSnap.id
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    },
    async getChapter() {
      const docRef = doc(firestore, "chapter", this.$route.params.id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        //console.log("Document data:", docSnap.data());
        this.content = docSnap.data()
        this.content.id = docSnap.id
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
      /* if(this.content)
      for(let i=0; i<this.content.subchapters.length; i++)
      {
        this.subChaptersList[i]=this.content.subchapters[i]
      } */
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getDatePlusSeven() {
      var currentDate = new Date().setDate(new Date().getDate() - 30)
      currentDate = new Date(currentDate)
      //console.log('>>>>>>>>> ',currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      return moment(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        )
      ).format('DD/MM/YYYY')
    },
    getCurrentDate() {
      var currentDate = new Date()
      //console.log('>>>>>>>>> ',currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      return moment(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate()
        )
      ).format('DD/MM/YYYY')
    },
    getFromToDate() {
      var index = this.selectedDate.indexOf(' to ')
      var indexTwo = this.selectedDate.indexOf(',')
      if (index >= 0) {
        //valid
        //console.log('>>>>>> I have to')
        this.fromDate = this.selectedDate.substring(0, index)
        this.toDate = this.selectedDate.substring(
          index + 4,
          this.selectedDate.length
        )
      } else if (indexTwo >= 0) {
        //valid
        //console.log('>>>>>> I have comma')
        this.fromDate = this.selectedDate.substring(0, indexTwo)
        this.toDate = this.selectedDate.substring(
          indexTwo + 1,
          this.selectedDate.length
        )
      }
    },
    getStatusState(item) {
      if (item === 'New') return 'badge-soft-danger'
      else return 'badge-soft-secondary'
    },
    getStageState(item) {
      if (item === 'Member Follow-up') return 'badge-soft-success'
      else if (item === 'No Action') return 'badge-soft-secondary'
      else if (item === 'Letter Sent') return 'badge-soft-primary'
      else return 'badge-soft-dark'
    },
    async downloadClicked() {
      await this.initializeData()
    },
    removeCharacters(text) {
      var returningValue = text + ''
      //console.log('>>>>>>>>>>>> Data: ', typeof(text))
      returningValue = returningValue.replace(',', ' to ')
      returningValue = returningValue.replace('[', '')
      returningValue = returningValue.replace(']', '')
      return returningValue
    },
    getStyle() {
      if (this.$i18n.locale == 'am')
        return "font-size-12_am"
      else
        return "font-size-12_en"
    },
    getTitleStyle() {
      if (this.$i18n.locale == 'am')
        return "titleAm"
      else
        return "titleEn"
    },
    getGreetingTitleStyle() {
      if (this.$i18n.locale == 'am')
        return "greetingTitleAm"
      else
        return "greetingTitleEn"
    },








    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    myRowClickHandler(record, index) {
      console.log(index + ' - ' + record.id + ' - ' + record.name) // This will be the item data for the row
      //this.$router.push({ name: 'View Content', params: { content: record } })
    },



    async readContents() {
      //console.log('got in here');
      let contentsData = []
      //var contentChaptersList=this.$route.params.content.chapters;
      let contentChaptersList = await this.getCourseChaptersList()
      //console.log('>>>>>>>>>> chapters: ' + contentChaptersList)

      contentChaptersList.forEach((chapter) => {
        this.chaptersList.forEach((dbChapter) => {
          if (dbChapter.id == chapter)
            contentsData.push(dbChapter)
        })
        //console.log('>>>>>>>>>> subchapter: ' + chapter)

      })

      this.noOfMembers = contentsData.length
      this.loadingData = false
      return contentsData
    },

    async getCourseChaptersList() {
      let chaptersList = [];
      const docRef = doc(firestore, "chapter", this.$route.params.id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        //console.log("Document data:", docSnap.data());
        chaptersList = docSnap.data().subchapters
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
      return chaptersList;
    },

    async readChapters() {
      //console.log('got in here');
      let chaptersList = []
      var content = null
      const contentsCol = collection(firestore, 'subchapter')
      const q = query(contentsCol, orderBy('created', 'desc'))
      const contentsSnapshot = await getDocs(q)
      //if(userCourseList)
      contentsSnapshot.forEach((doc) => {
        content = doc.data()
        content.id = doc.id
        chaptersList.push(content)
      });
      return chaptersList;
    },


    tagsHaveThisValue(tags, searchValue) {
      var returnValue = false;
      //console.log('>>>>>>>>>> tags: '+tags+' | searchValue: '+searchValue)
      tags.forEach((tag) => {
        if (tag.toLowerCase().includes(searchValue)) {
          //console.log('>>>>>>>>>> '+tag+' | '+true)
          returnValue = true
        }
      })

      return returnValue
    },

    decryptData(encryptedData) {
      return CryptoJS.AES.decrypt(encryptedData, this.secret).toString(
        CryptoJS.enc.Utf8
      )
    },

    indexChecker(index) {
      //console.log('>>>>>>>>>>>>>> '+((this.currentPage-1)*this.perPage))
      return (
        index >= (this.currentPage - 1) * this.perPage &&
        index < this.currentPage * this.perPage
      )
    },


    showToolFunction(tool)
    {
      //console.log('>>>>>>>>>>>>>>> Got in here')
      var content=''
      var title=''
      //if(tool.description.length>0)
      if(tool.fileName.length>0)
      {
        title='Tool'
        content+=tool.description
        if(tool.tip.length>0)
        {
        content+='\n\nTip: '
        content+=tool.tip
        }
      }
      //else if(tool.tip.length>0)
      else
      {
        //title='Tip'
        //content+=tool.tip
        title='Tip'
        content+=tool.description
        if(tool.tip.length>0)
        {
        content+=tool.tip

        }
      }

      this.infoModal.title = title
      this.infoModal.content = content
      this.infoModal.fileName = tool.fileName
      //this.$root.$emit('bv::show::modal', this.infoModal.id)
      this.$refs['info-modal'].show()
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
      this.infoModal.fileName = ''
    },


  },
}
</script>

<template>
  <Layout>

    <div v-if="this.parentContent && this.content" class="row page-title">
      <div class="col-lg-12">
        <h6>
          <router-link :to="{ name: 'Dashboard' }">
            Gebi</router-link>
          /
          <router-link :to="{ name: 'Chapters', params: { content: this.parentContent, id: this.parentContent.id } }">
            {{ this.parentContent.title }}</router-link>
          /
          <router-link
            :to="{ name: 'SubChapters', params: { content: this.parentContent, pid: this.parentContent.id, id: this.content.id } }">
            {{ this.content.title }}</router-link>
          /
          Tools
        </h6>
      </div>
    </div>
  <div class="row">
    <b-modal ref="info-modal" :title="infoModal.title" centered button-size="lg" okOnly
      titleTag="h4" body-text-variant="dark"
                    @hide="resetInfoModal">
      <p class="big">{{ infoModal.content }}</p>
      <a v-if="infoModal.fileName.length>0" :href="infoModal.fileName" target="_blank"><b-button size="md" variant="primary" class="block">
            Open Tool
          </b-button></a>
    </b-modal>
  </div>

    <div class="row">
      <div class="col-lg-12">
        <h6 class="mb-1 mt-0">&nbsp;</h6>
        <b-alert :show="loadingData" dismissible fade variant="success">
          <h6 style="color: white" :class="getStyle()">Updating page. Please wait.</h6>
        </b-alert>
      </div>
    </div>

    <div v-if="this.content" class="row">
      <div class="col-lg-12">
        <h2 class="greetingTtitle">Tools - {{ this.content.title }}</h2>
        <h5 class="text-muted font-weight-normal mt-1 mb-3">{{ this.content.description }}</h5>
        <h5 class="mb-1 mt-0">&nbsp;</h5>
      </div>
    </div>


    <div v-if="this.content" class="row row-class">
      <div v-for="(contentInfo, index) in toolsContentList" :key="index" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-2">
        <Tool :toolContent="contentInfo" :content="content" :parentContent="parentContent" @showTool="showToolFunction($event)" />
      </div>
    </div>

    <div v-if="noOfMembers > 0 && filteredItems.length > perPage" class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
          </ul>
        </div>
      </div>
    </div>


  </Layout>
</template>
<style scoped>
.vertical-center {
  margin: 0;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.primary-text-one {
  color: #000;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.7px;
  margin-left: 20px;
  margin-right: 20px;
}

.secondary-text-two {
  color: #ccc;
  font-weight: 100;
  font-size: 12px;
  letter-spacing: 1px;
  margin-left: 20px;
  margin-right: 20px;
}

.secondary-text-three {
  color: blue;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 1px;
  margin-left: 20px;
  margin-right: 20px;
}

.card.cardd {
  height: 350px;
  width: 100%;
  background-color: #E3E3E3;
  border-radius: 16px;
  text-align: center;
}

.card.more-card {
  height: 200px;
  width: 100%;
  background-color: rgb(255, 255, 255);
  border-radius: 16px;
  text-align: left;
}

.chart {
  width: 100%;
  height: 300px;
}

.font-size-12_en {
  font-size: 12px !important;
  text-transform: uppercase !important;
  font-weight: 700 !important;
}

.font-size-12_am {
  font-size: 15px !important;
  text-transform: uppercase !important;
  font-weight: 500 !important;
}

.titleAm {
  font-size: 22px !important;
  font-weight: 400 !important;
}

.titleEn {
  font-size: 19px !important;
  font-weight: 600 !important;
}

.greetingTitleAm {
  font-size: 2.75rem !important;
  font-weight: 200 !important;
}

.greetingTtitleEn {
  font-size: 2.75rem !important;
  font-weight: 100 !important;
}

.greetingTtitle {
  font-size: 2.75rem !important;
  font-weight: 100 !important;
}
</style>